import {
  createTableColumn,
  Link,
  TableColumnDefinition,
} from "@fluentui/react-components";
import { IEmailTemplate } from "../../../Models/IEmailTemplate";

interface IEmailTemplateColumnsProps {
  onClickedEmailTemplate(item: IEmailTemplate): void;
}

export function EmailTemplateColumns(props: IEmailTemplateColumnsProps) {
  const columns: TableColumnDefinition<IEmailTemplate>[] = [
    createTableColumn<IEmailTemplate>({
      columnId: "name",
      compare: (a, b) => {
        return a.name.localeCompare(b.name);
      },
      renderHeaderCell: () => {
        return "Name";
      },
      renderCell: (item: IEmailTemplate) => {
        return (
          <Link
            onClick={() => {
              props.onClickedEmailTemplate(item);
            }}
          >
            {item.name}
          </Link>
        );
      },
    }),
    createTableColumn<IEmailTemplate>({
      columnId: "sprache",
      compare: (a, b) => {
        return a.sprache.localeCompare(b.sprache);
      },
      renderHeaderCell: () => {
        return "Sprache";
      },
      renderCell: (item: IEmailTemplate) => {
        return <div>{item.sprache}</div>;
      },
    }),
    createTableColumn<IEmailTemplate>({
      columnId: "subject",
      compare: (a, b) => {
        return a.subject.localeCompare(b.subject);
      },
      renderHeaderCell: () => {
        return "Titel";
      },
      renderCell: (item: IEmailTemplate) => {
        return <div>{item.subject}</div>;
      },
    }),
  ];
  return columns;
}
